import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from "../../shared/service/auth.service";
import { FireAssessmentService } from "../../services/fire-assessment.service";
import { AngularFireStorage } from "@angular/fire/storage";
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { ResourceLoader } from '@angular/compiler';
import { state } from '@angular/animations';
import { FireActionItemService } from "../../services/fire-action-items/fire-action-item.service";
import  Validation  from 'validation-utils';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';



@Component({
  selector: 'app-on-board',
  templateUrl: './on-board.component.html',
  styleUrls: ['./on-board.component.scss']
})
export class OnBoardComponent implements OnInit {
  @ViewChild('UploadProfilePhoto') uploadProfilePhoto:ElementRef;
  fileName = 'Select Photo';

  //the onBoarding Form
  onBoardingForm: FormGroup = new FormGroup({
   displayName: new FormControl(''),
   typeOfUser: new FormControl(''),
   firstName: new FormControl(''),
   lastName: new FormControl(''),
   companyName: new FormControl(''),
   refferedBy: new FormControl(''),
   acceptTerms: new FormControl(false),
  });

  submitted = false;
  selectedOption :string;

  typeOfUsers = [
    {type:"Admin", value: "Admin"},
    {type:"Entrepreneur", value: "Entrepreneur"}
  ]
    
  
  constructor(
    private formBuilder : FormBuilder,
    public authService: AuthService
  ) { }

  ngOnInit(): void {
    this.onBoardingForm = this.formBuilder.group({
      displayName: ['', Validators.required],
      typeOfUser: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      companyName:['', Validators.required],
      refferedBy :[''],
      acceptTerms:[false, Validators.requiredTrue]
    });

    this.authService.hideNav();
  }
get f(): {[key:string]:AbstractControl} {
  return this.onBoardingForm.controls;
}

onSubmit():void{
  this.submitted = true;
  if (this.onBoardingForm.invalid){
    return 
  }
  let dpName, typeUser, fName, lName, cName, refBy,aTerm;
    dpName = this.onBoardingForm.value.displayName;
    typeUser = this.onBoardingForm.value.typeOfUser;
    fName = this.onBoardingForm.value.firstName;
    lName = this.onBoardingForm.value.lastName;
    cName = this.onBoardingForm.value.companyName;
    refBy = this.onBoardingForm.value.refferedBy;
    aTerm = this.onBoardingForm.value.acceptTerms;
    this.authService.onboardUpdate(dpName, typeUser,fName,lName,cName,refBy,aTerm)
  }

onReset(): void {
  this.submitted = false;
  this.onBoardingForm.reset();
}  
 

}
